<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push('/home').catch(() => {})"
        :content="$t('encontre-cep')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-row type="flex">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-divider>{{ $t("pelo-cep") }}</el-divider>
        </el-col>
      </el-row>
      <el-form :model="ruleForm" ref="ruleForm" label-width="20%">
        <el-row type="flex">
          <el-form-item :label="$t('cep')" prop="code">
            <el-col :xs="14" :sm="14" :md="14" :lg="14" :xl="14">
              <el-input
                v-mask="'#####-###'"
                placeholder="00000-000"
                v-model="zipcode"
                v-on:keyup.native.enter="search(1)"
              >
              </el-input>
            </el-col>
            <el-col :xs="8" :sm="8" :md="8" :lg="6" :xl="6">
              <el-button
                type="info"
                icon="el-icon-search"
                @click="search(1)"
              ></el-button>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <el-row type="flex">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-divider>{{ $t("pelo-endereco") }}</el-divider>
        </el-col>
      </el-row>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="20%"
        label-position="top"
      >
        <el-row type="flex">
          <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="3">
            <el-form-item :label="$t('estado')" prop="code">
              <StateList v-model="ruleForm.state" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="code">
              <el-select
                placeholder="Selecione uma cidade"
                v-model="ruleForm.city"
                filterable
                v-loading="loading"
              >
                <el-option
                  v-for="row in city"
                  :key="row.id"
                  :value="row.nome"
                  >{{ row.nome }}</el-option
                >
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('endereco')" prop="code">
              <el-input
                placeholder="Rua, Av Santos Dumont"
                v-model="ruleForm.address"
                class="input-with-select"
                v-on:keyup.native.enter="search(2)"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="12"
            :lg="2"
            :xl="2"
            style="margin-top: 50px"
          >
            <el-button
              type="info"
              icon="el-icon-search"
              @click="search(2)"
            ></el-button>
          </el-col>
        </el-row>
      </el-form>
      <br />
      <el-table
        v-show="tableData.length > 0"
        :data="tableData"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column sortable prop="cep" :label="$t('cep')">
          <template slot-scope="scope">
            {{ scope.row.cep }}&nbsp;<i
              class="el-icon-document-copy"
              v-clipboard:copy="scope.row.cep"
              @click="copy()"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="end"
          :label="$t('logradouro')"
        ></el-table-column>
        <el-table-column prop="bairro" :label="$t('bairro')"></el-table-column>
        <el-table-column prop="cidade" :label="$t('cidade')"></el-table-column>
        <el-table-column prop="uf" :label="$t('estado')"></el-table-column>
        <el-table-column
          prop="complemento2"
          :label="$t('complemento')"
        ></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
//import { UserService } from "@/services/users/user.services";
import { i18n } from "@/plugin/i18n";
import StateList from "@/xpost/views/services/search.cep/StateList";
import { IbgeService } from "@/services/customers/ibge.services";
import { PostOfficeService } from "@/services/post.office/post.office.services";

export default {
  name: "SearchCep",
  components: { StateList },
  data() {
    return {
      show: false,
      reverse: false,
      filter: "",
      zipcode: "",
      city: [],
      loading: false,
      ruleForm: { city: "", state: "", address: "" },
      tableData: [],
    };
  },
  watch: {
    "ruleForm.state": function () {
      const vm = this;
      vm.city = [];
      vm.ruleForm.city = "";
      vm.loading = true;
      IbgeService.byState(vm.ruleForm.state)
        .then((response) => {
          function compare(a, b) {
            if (a.nome < b.nome) return -1;
            if (a.nome > b.nome) return 1;
            return 0;
          }
          vm.city = response.sort(compare);
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  methods: {
    search(type) {
      var vm = this;
      if (type === 1) {
        vm.searchByCep();
      } else {
        vm.searchByAddress();
      }
    },
    copy() {
      this.$message({
        type: "success",
        message: "CEP copiado com sucesso",
      });
    },
    searchByCep() {
      const vm = this;
      vm.tableData = [];
      if (!vm.zipcode) {
        return this.$message({
          type: "error",
          message: "Informe um CEP!",
        });
      }
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      PostOfficeService.zipcode(vm.zipcode)
        .then((response) => {
          vm.tableData.push(response);
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    searchByAddress() {
      const vm = this;
      if (!vm.ruleForm.state || !vm.ruleForm.city || !vm.ruleForm.address) {
        return this.$message({
          type: "error",
          message:
            "Favor informar todos os campos de estado, cidade e endereço",
        });
      }
      if (vm.ruleForm.address.length < 3) {
        return this.$message({
          type: "error",
          message: "Informe ao menos três caracteres no endereço!",
        });
      }
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      vm.tableData = [];
      PostOfficeService.address(
        vm.ruleForm.state,
        vm.ruleForm.city,
        vm.ruleForm.address
      )
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      /*    const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      UserService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());*/
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>